import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {PopCardComponent} from './pop-card.component'
import {MatCardModule} from '@angular/material/card'

@NgModule({
  declarations: [
    PopCardComponent
  ],
  imports: [
    MatCardModule,
    CommonModule
  ],
  exports: [
    PopCardComponent,
  ]
})
export class PopCardModule {}
